//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import colors from "@/assets/theme/colors";
import { ArcElement, CategoryScale, Chart as ChartJS, Legend, Title, Tooltip } from "chart.js";
import { Doughnut as DoughnutBarGenerator } from "vue-chartjs/legacy";
import VueI18n from "vue-i18n";
import DoughnutChartInfo from "./DoughnutChartInfo.vue";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

// Temporary solution until we can upgrade chart.js library
// and use arrow functions for external tooltips
function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (const element of ca) {
    let c = element;
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const es = {
  dashboard: {
    charts: {
      status: {
        values: {
          low: "Conectados",
          medium: "Desconectados < 12h",
          hard: "Desconectados > 12h",
        },
      },
    },
  },
};
const en = {
  dashboard: {
    charts: {
      status: {
        values: {
          low: "Online",
          medium: "Offline < 12h",
          hard: "Offline > 12h",
        },
      },
    },
  },
};

const messages = { en, es };

let i18n;
function tempTranslation(value) {
  i18n = new VueI18n({
    locale: getCookie("i18n_redirected") || "es", // set locale
    messages, // set locale messages
  });
  return i18n.t(value[0].split(":")[0]);
}

// End of temporary solution

export default {
  name: "DoughnutChart",
  components: {
    DoughnutBarGenerator,
    DoughnutChartInfo,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    alert: {
      type: Boolean,
      default: false,
    },
    elements: {
      type: Array,
      default: () => [],
    },
    emptyMessage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      locale: "",
    };
  },
  computed: {
    computedElements() {
      return this.elements.length
        ? this.elements
        : [
            {
              color: colors.primary.DEFAULT,
              value: 100,
            },
            {
              color: colors.primary.light,
              value: 50,
            },
            {
              color: colors.primary.lightest,
              value: 25,
            },
          ];
    },
    config() {
      return {
        chartData: {
          // Data to be represented on x-axis
          labels: this.computedElements.map((element) => element.name),
          datasets: [
            {
              backgroundColor: this.computedElements.map((element) => element.color),
              borderWidth: 1,
              data: this.computedElements.map((element) => element.value),
            },
          ],
        },
        chartOptions: {
          cutoutPercentage: 50,
          hover: false,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              position: "nearest",
              enabled: false,
              external: (context) => {
                // Tooltip Element
                let tooltipEl = document.getElementById("chartjs-tooltip");

                // Create element on first render
                if (!tooltipEl) {
                  tooltipEl = document.createElement("div");
                  tooltipEl.id = "chartjs-tooltip";
                  tooltipEl.innerHTML = "<table></table>";
                  document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                const tooltipModel = context.tooltip;
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                tooltipEl.classList.add("ease-in-out", "transition-all", "duration-250");

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                // Set Text
                if (tooltipModel.body) {
                  const titleLines = tooltipModel.title || [];
                  const bodyLines = tooltipModel.body.map(getBody);

                  let innerHtml = "<thead>";

                  titleLines.forEach((title) => {
                    innerHtml += `<tr><th>${title}</th></tr>`;
                  });
                  innerHtml += "</thead><tbody>";

                  bodyLines.forEach((body) => {
                    innerHtml += `<tr><td class="bg-status-warning text-back-lightest px-2 py-1 rounded-md shadow-lg">${tempTranslation(
                      body,
                    )}</td></tr>`;
                  });
                  innerHtml += "</tbody>";

                  const tableRoot = tooltipEl.querySelector("table");
                  tableRoot.innerHTML = innerHtml;
                }

                // Display, position, and set styles for font
                const position = context.chart.canvas.getBoundingClientRect();

                tooltipEl.style.zIndex = 50;
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left = `${position.left + window.scrollX + tooltipModel.caretX}px`;
                tooltipEl.style.top = `${position.top + window.scrollY + tooltipModel.caretY}px`;
                tooltipEl.style.fontFamily = tooltipModel.options.bodyFont.family;
                tooltipEl.style.fontSize = `${tooltipModel.options.bodyFont.size}px`;
                tooltipEl.style.fontStyle = tooltipModel.options.bodyFont.style;
                tooltipEl.style.padding = `${tooltipModel.padding}px ${tooltipModel.padding}px`;
                tooltipEl.style.pointerEvents = "none";
              },
            },
          },
          maintainAspectRatio: false,
          responsive: true,
        },
      };
    },
    emptyElements() {
      return [
        {
          color: this.alert ? colors.status.warning : colors.primary.DEFAULT,
          name: this.emptyMessage,
        },
      ];
    },
    isEmpty() {
      return this.elements.length === 0;
    },
  },
  created() {
    // Hack because we don't want the default (correct) thousands separator for spanish locale
    this.locale = this.$i18n.locale === "es" ? "de" : this.$i18n.locale;
  },
  methods: {},
};
